export default __webpack_public_path__ + "media/610ed54cd50794d9ae909c9c13d0f0459247bcd7e768f82abc5fad01fd684ddc.svg";